import { theme } from "antd";
import "../../styles/loader.css";

function Loader({ size = 56 }) {
  const {
    token: { colorPrimary },
  } = theme.useToken();
  return (
    <div
      style={{
        width: size,
        height: size,
      }}
      className="spinner"
    ></div>
  );
}

export default Loader;
